<script setup>
import { TriangleAlert } from "@lucide/vue";
import UiDrawer from "./UiDrawer.vue";
import UiButton from "./UiButton.vue";
defineProps({
  open: Boolean,
  title: { type: String, default: "İşlemi onaylayın" },
  description: String,
  confirmLabel: { type: String, default: "Onayla" },
  loading: Boolean,
});
defineEmits(["close", "confirm"]);
</script>
<template>
  <UiDrawer :open="open" :title="title" eyebrow="Onay gerekli" size="md" @close="$emit('close')">
    <div class="flex gap-4 rounded-lg border border-amber-200 bg-amber-50 p-4">
      <span class="grid size-10 shrink-0 place-items-center rounded-md bg-amber-100 text-amber-700"><TriangleAlert class="size-5" /></span>
      <div>
        <strong class="block text-sm text-ink-950">Bu işlem geri alınamayabilir</strong>
        <p class="mt-1 text-sm leading-6 text-slate-600">{{ description }}</p>
      </div>
    </div>
    <template #footer>
      <UiButton variant="secondary" @click="$emit('close')">Vazgeç</UiButton>
      <UiButton variant="danger" :loading="loading" @click="$emit('confirm')">{{ confirmLabel }}</UiButton>
    </template>
  </UiDrawer>
</template>

